import { render, staticRenderFns } from "./NavMain.vue?vue&type=template&id=09bc5cc8&"
import script from "./NavMain.vue?vue&type=script&lang=js&"
export * from "./NavMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports